import { Box } from "@braintrust/braintrust-ui-components";
import { ViewJobButton } from "@js/apps/jobs/components//view-job-button";
import type { MainJobListingJob } from "@js/types/jobs";

import styles from "./styles.module.scss";

type JobItemButtonsProps = {
  isTablet: boolean;
  isMobile: boolean;
  job: MainJobListingJob;
};

export const JobItemButtonsEmbedded = ({
  isMobile,
  job,
}: JobItemButtonsProps) => {
  return (
    <Box className={styles.wrapper}>
      <ViewJobButton
        job={job}
        variant="primary"
        color="primary"
        fullWidth={isMobile}
        sx={{
          display: { xs: "none", sm: "flex" },
          flexShrink: 0,
          height: 40,
        }}
      />
    </Box>
  );
};
